module.exports = __webpack_public_path__ + "static/media/bg.fbf227b5.jpg";